import { useModel as _useModel, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, isRef as _isRef, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

import {computed, ref} from 'vue';
import ElConfirm from "~/core-ui/vue/ui/ElConfirm";
import {__} from "~/ts/library/Translate";
import OperatorApiRequest from "~/operatorApplication/ts/request/OperatorApiRequest";
import MyDialog from "~/cabinet/vue/interface/dialog/MyDialog.vue";
import TextInputWithVariables from "~/cabinet/vue/interface/tinymce/TextInputWithVariables.vue";
import {OperatorAccountStore} from "~/operatorApplication/ts/store/OperatorAccountStore";
import HelpBlock from "~/cabinet/vue/interface/HelpBlock.vue";
import {ElNotification} from "element-plus";



import {defineComponent} from 'vue';

const __default__ = defineComponent({
    name: "OperatorApplicationFinishAllHaveNoAnswerDialog"
});

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    "visible": { type: Boolean },
    "visibleModifiers": {},
  },
  emits: ["update:visible"],
  setup(__props) {

let isVisible = _useModel<boolean>(__props, "visible");

function close() {
    isVisible.value = false;
}

let sendMessage = ref(false);
let text = ref<string>(null);

async function finishAllHaveNoAnswer() {
    let p: OperatorApplicationApi.OperatorBuddyAllFinishHaveNoAnswerOpenApiModel = {
        message: sendMessage.value ? {
            content: {
                text: text.value
            }
        } : null
    };
    try {
        await ElConfirm(__("Вы хотите завершить все Offline вопросы?"));
        let send = (new OperatorApiRequest({
            url: "/buddyList/finishAllHaveNoAnswer",
            p,
            silent: true
        })).save();
        close();
        let notification = ElNotification.info({
            title: __('Завершить все Offline вопросы'),
            message: __('Подождите, идёт сохранение')
        });
        let result = await send;
        try {
            notification.close();
        } catch (e) {
        }
        result.showMessage();
    } catch (e) {

    }
}

let canFormatText = computed(() => OperatorAccountStore.data.value.accessRights.canFormatText);


return (_ctx: any,_cache: any) => {
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_form = _resolveComponent("el-form")!

  return (_openBlock(), _createBlock(MyDialog, {
    visible: _unref(isVisible),
    "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => (_isRef(isVisible) ? (isVisible).value = $event : isVisible = $event)),
    title: _unref(__)('Завершить все Offline вопросы'),
    onApply: finishAllHaveNoAnswer
  }, {
    default: _withCtx(() => [
      _createVNode(_component_el_form, { "label-position": "top" }, {
        default: _withCtx(() => [
          _createVNode(_component_el_form_item, null, {
            default: _withCtx(() => [
              _createVNode(_component_el_switch, {
                modelValue: _unref(sendMessage),
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(sendMessage) ? (sendMessage).value = $event : sendMessage = $event)),
                class: "mr-2"
              }, null, 8, ["modelValue"]),
              _createTextVNode(" " + _toDisplayString(_unref(__)('Отправить клиентам сообщение')) + " ", 1),
              (!_unref(sendMessage))
                ? (_openBlock(), _createBlock(HelpBlock, {
                    key: 0,
                    class: "mt-4"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(__)("Вопросы будут завершены без отправки сообщений клиентам")), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          (_unref(sendMessage))
            ? (_openBlock(), _createBlock(_component_el_form_item, {
                key: 0,
                label: _unref(__)('Текст сообщения')
              }, {
                default: _withCtx(() => [
                  _createVNode(TextInputWithVariables, {
                    disabled: !_unref(sendMessage),
                    modelValue: _unref(text),
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_isRef(text) ? (text).value = $event : text = $event)),
                    "max-height": 300,
                    "min-height": 53,
                    bbcode: _unref(canFormatText),
                    multiline: "",
                    "auto-focus": ""
                  }, null, 8, ["disabled", "modelValue", "bbcode"])
                ]),
                _: 1
              }, 8, ["label"]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["visible", "title"]))
}
}

})